import { render, staticRenderFns } from "./ManageRateProfile.vue?vue&type=template&id=1fa67913&scoped=true"
import script from "./ManageRateProfile.vue?vue&type=script&lang=js"
export * from "./ManageRateProfile.vue?vue&type=script&lang=js"
import style0 from "./ManageRateProfile.vue?vue&type=style&index=0&id=1fa67913&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa67913",
  null
  
)

export default component.exports